import { Button as FlowbiteButton } from "flowbite-react";
import './button.css';

/**
 * Button Component
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - Button content/text
 * @param {Function} props.onClick - Click handler function
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.variant - Button variant ('primary', 'secondary', 'tertiary', 'danger', 'ghost')
 * @param {React.ReactNode} props.leftIcon - Icon to display on the left side
 * @param {React.ReactNode} props.rightIcon - Icon to display on the right side
 * @param {boolean} props.disabled - Whether the button is disabled
 * @param {Object} props.rest - Additional props passed to Flowbite Button
 */
const Button = ({
    children,
    onClick,
    className = '',
    variant = 'primary',
    leftIcon,
    rightIcon,
    disabled = false,
    ...rest
}) => {
    const getVariantClasses = () => {
        switch (variant) {
            case 'primary':
                if (disabled) {
                    return 'btn-primary-disabled';
                }
                return 'btn-primary';
            case 'secondary':
                if (disabled) {
                    return 'btn-secondary-disabled';
                }
                return 'btn-secondary';
            case 'tertiary':
                if (disabled) {
                    return 'btn-tertiary-disabled';
                }
                return 'btn-tertiary';
            case 'danger':
                if (disabled) {
                    return 'btn-danger-disabled';
                }
                return 'btn-danger';
            case 'ghost':
                if (disabled) {
                    return 'btn-ghost-disabled';
                }
                return 'btn-ghost';
            default:
                if (disabled) {
                    return 'btn-primary-disabled';
                }
                return 'btn-primary';
        }
    };

    return (
        <FlowbiteButton
            size="sm"
            className={`${getVariantClasses()} shrink-0 ${className}`}
            onClick={onClick}
            disabled={disabled}
            {...rest}
        >
            <div className="flex items-center whitespace-nowrap text-body font-medium leading-[150%]">
                {leftIcon && <span className="mr-2 flex shrink-0 items-center">{leftIcon}</span>}
                <span className="flex items-center whitespace-nowrap">{children}</span>
                {rightIcon && <span className="ml-2 flex shrink-0 items-center">{rightIcon}</span>}
            </div>
        </FlowbiteButton>
    );
};

export default Button;
